import axios from 'axios';
import storageService, { Locals } from './storageService';
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry';
import globalErrorUtils from '../hooks/globalErrorUtils';

const headers = (): any => {
    const accessToken = storageService.getObject(Locals.ACCESS_TOKEN);
    if (accessToken) {
        return {
            Authorization: `Bearer ${accessToken}`,
        };
    } else {
        return {};
    }
};

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: headers(),
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        throw error.response;
    }
);

const updateHeaders = () => {
    Object.assign(api.defaults.headers, headers());
};

axiosRetry(api, {
    retries: 3,
    retryCondition: (e): any => {
        return (
            isNetworkOrIdempotentRequestError(e) ||
            (e.response && e.response.status === 404)
        );
    },
    retryDelay: axiosRetry.exponentialDelay,
});

export { api, updateHeaders };
